
import React from "react";
import { Button } from "@/components/ui/button";
import { Edit, Trash } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger
} from "@/components/ui/alert-dialog";
import { Worksheet } from "@/hooks/worksheet/useWorksheetAPI";

interface WorksheetTableActionsProps {
  worksheet: Worksheet;
  onEditClick: (worksheet: Worksheet) => void;
  onDeleteClick: (id: number) => void;
}

export const WorksheetTableActions: React.FC<WorksheetTableActionsProps> = ({
  worksheet,
  onEditClick,
  onDeleteClick
}) => {
  return (
    <div className="text-right space-x-2">
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => onEditClick(worksheet)}
        className="h-8 px-2 py-1"
      >
        <Edit className="h-4 w-4 mr-1" /> แก้ไข
      </Button>
      
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button 
            variant="destructive" 
            size="sm"
            className="h-8 px-2 py-1"
          >
            <Trash className="h-4 w-4 mr-1" /> ลบ
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>ยืนยันการลบชีท</AlertDialogTitle>
            <AlertDialogDescription>
              คุณแน่ใจหรือไม่ว่าต้องการลบชีท "{worksheet.name}"?
              การลบจะไม่สามารถกู้คืนได้
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>
              ยกเลิก
            </AlertDialogCancel>
            <AlertDialogAction onClick={() => onDeleteClick(worksheet.id)} className="bg-red-600 hover:bg-red-700">
              ยืนยันการลบ
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
